const DateTimeBadge = ({ date }) => {
    if (!date) return null;
    
    const formatted = new Date(date)
        .toLocaleString("en-GB", {
            timeZone: "Asia/Muscat",
            hour12: true,
            day: "numeric",
            month: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
        })
        .replace(/\b(am|pm)\b/i, (m) => m.toUpperCase());

    const parts = formatted.replace(",", "").split(" ");
    const formattedDate = parts[0];
    const formattedTime = `${parts[1]} ${parts[2]}`;


    return (
        <span className="inline-flex flex-col">
            <span className="text-sm font-medium text-gray-900 ">
                {formattedDate}
            </span>
            <span className="text-xs font-semibold text-green-500 tracking-wide">
                {formattedTime}
            </span>
        </span>
    );
};

export default DateTimeBadge;
